import { httpCreate, getUrlPath } from './http';

const http = httpCreate('/shop/api/trxOrder');

export const shopTrxOrder = {
	umGetListByUserId(userId, params) {
		return http.get(`/userMange/${userId}`, { params });
	},
	addWheelCount(wheelActivityId, orderNo) {
		return http.post(`/addWheelCount/${wheelActivityId}?orderNo=${orderNo}`);
	},
};
